import { getFullUrl } from 'hubspot-url-utils';
import getLang from 'LearningCenterUI/utils/getLang';
import { DEFAULT_LANGUAGE } from '../constants/ApiConstants';
const ONE_MINUTE_IN_SECONDS = 60;
const LANG_CODE_TO_NAME = {
  en: 'english',
  fr: 'french',
  de: 'german',
  es: 'spanish',
  pt: 'portuguese',
  ja: 'japanese'
};
const isChirpDescriptions = descriptions => {
  const languageNames = Object.values(LANG_CODE_TO_NAME);
  return Object.keys(descriptions).some(key => languageNames.includes(key));
};

/**
 * This calculates the number of seconds that we should use to estimate how long an exam will take.
 * @param {number} questionCount - the number of questions in the exam
 * @returns {number} - the number of seconds in the computed duration of the exam
 */
export function calculateExamDurationSeconds(questionCount) {
  return questionCount * ONE_MINUTE_IN_SECONDS;
}
export function getProfessorDescription(professor, language = getLang()) {
  if (Object.keys(professor.descriptions).length === 0) {
    return undefined;
  }
  const descriptions = professor.descriptions;
  const langCode = language.toLowerCase();
  const langName = LANG_CODE_TO_NAME[langCode];

  /**
   * CHIRP -> { english: '', french: '', ... }
   * LEGACY -> { en: '', fr: '', ... }
   */
  const byExactLanguage = isChirpDescriptions(descriptions) ? langName && descriptions[langName] : descriptions[langCode];
  const byDefaultLanguage = isChirpDescriptions(descriptions) ? descriptions['english'] : descriptions[DEFAULT_LANGUAGE];
  return byExactLanguage || byDefaultLanguage || Object.values(descriptions).find(Boolean);
}
export function getFormattedExerciseLocation(rawLocation, portalId) {
  const link = `${getFullUrl('app')}/${rawLocation.replace('/l/', `/${portalId}/`)}`;

  // special snowflake redirect (https://git.hubteam.com/HubSpot/LearningCenterUI/issues/1111)
  const maybeContainsRedirect = rawLocation.match(/academy\/l\/\?redirect=(.+)/);
  if (maybeContainsRedirect) {
    const redirectUrl = maybeContainsRedirect[1];
    // sanity check of the domain
    if (/^http(s?):\/\/([a-z]*).hubspot((qa)?).com/.test(redirectUrl)) {
      return redirectUrl;
    }
  }
  return link;
}